import { z } from 'zod'
import type { UserRole } from '~/server/db/schema'

export const authUserSchema = z.object({
	id: z.string().uuid(),
	email: z.string().email(),
	role: z.enum(['admin', 'editor', 'viewer']) as z.ZodType<UserRole>,
})

export type AuthUser = z.infer<typeof authUserSchema>

export const authMeResponseSchema = z.object({
	user: authUserSchema,
})

export type AuthMeResponse = z.infer<typeof authMeResponseSchema>
